import React from 'react';
import { XIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function FailedSolutionsSection() {
  const failures = [{
    title: 'Las pastillas y la melatonina',
    description: 'Solo apagan el síntoma, pero no detienen el ruido mental; por eso despiertas a las 3 AM con el corazón acelerado.'
  }, {
    title: 'La meditación tradicional',
    description: 'Intentar "poner la mente en blanco" cuando estás ansioso es como intentar detener un tren con las manos; solo genera más frustración.'
  }, {
    title: 'La higiene del sueño genérica',
    description: 'Dejar el café o el celular ayuda, pero no sirve para cerrar los "ciclos abiertos" de pensamientos intrusivos.'
  }];
  return <section className="relative z-10 py-24 px-4" data-id="element-16">
      <div className="max-w-5xl mx-auto" data-id="element-17">
        <FadeIn data-id="element-18">
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-16" data-id="element-19">
            Por Qué Lo Que Has Probado{' '}
            <span className="text-rose-400" data-id="element-20">No Funciona</span>
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-21">
          {failures.map((item, index) => <FadeIn key={index} delay={index * 0.15} className="glass-card p-8 relative overflow-hidden group" data-id="element-22">
              <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-23">
                <XIcon className="w-24 h-24 text-rose-500" data-id="element-24" />
              </div>
              <div className="relative z-10" data-id="element-25">
                <div className="w-12 h-12 rounded-full bg-rose-500/20 flex items-center justify-center mb-6 border border-rose-500/30" data-id="element-26">
                  <XIcon className="w-6 h-6 text-rose-400" data-id="element-27" />
                </div>
                <h3 className="text-xl font-bold text-white mb-4 font-serif" data-id="element-28">
                  {item.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-29">
                  {item.description}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}